import * as React from 'react';

import initializeGoogle from 'helpers/initializeGoogle';
import PageLoadSpinner from 'components/PageLoadSpinner';

const GoogleApiContext = React.createContext(null);
GoogleApiContext.displayName = 'GoogleApiContext';

function GoogleApiProvider(props) {
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    initializeGoogle(() => setIsLoaded(true));
  }, []);

  if (!isLoaded) {
    return <PageLoadSpinner />;
  }

  return (
    <GoogleApiContext.Provider value={[isLoaded, setIsLoaded]} {...props} />
  );
}

function useGoogleApi() {
  const context = React.useContext(GoogleApiContext);
  if (context === undefined) {
    throw new Error('useAccount must be used within a AccountProvider');
  }
  const [isGoogleApiLoaded] = context;

  return isGoogleApiLoaded;
}
export { GoogleApiProvider, useGoogleApi };
